import React from 'react';
import { XIconSmall } from '../../components/icons';
import { useState, useEffect } from 'react';
import immer from 'immer';
import { SidebarSummaryStyles, SummaryHeader, OrderInfo, TabStyles, OuterWrap, TitleStyles } from './styles';
import { Order, Search } from '../types';
import Files from './Files';
import OrderCompleted from './OrderCompleted';
import groupBy from 'lodash.groupby';
import moment from 'moment-timezone';
import SearchesDelivered from './SearchesDelivered';

interface Props {
  onClick?: () => void;
  order: Order;
  status: string;
}
function GetDateInCurrentTimeZone(date: any) {
  const browserTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const utcDate = moment.tz(date, 'Universal');
  return moment(utcDate).tz(browserTZ);
}

const groupByType = (searches: Search[]) => {
  return groupBy(searches, s => {
    if (!s.continOrUpdateNumber) {
      return s.searchTypeTruncated;
    }
    if ([2, 3].includes(s.searchCategoryId)) {
      return `${s.searchTypeTruncated} Contin`;
    }
    return `${s.searchTypeTruncated} Update`;
  });
};
const SidebarSummary = (props: Props) => {
  const [orderSummaryOpen, setOrderSummaryOpen] = useState(true);
  const [activityOpen, setActivityOpen] = useState(false);
  const [searches, setSearches] = useState<Search[]>([]);
  const grouped = groupByType(searches);
  const date = GetDateInCurrentTimeZone(props.order.orderDate).format('MM/DD/YYYY');
  useEffect(() => {
    const allOrderSearches = immer(searches, () => {
      return props.order.properties.reduce<Search[]>((pre, cur) => {
        return pre.concat(cur.searches);
      }, []);
    });
    setSearches(allOrderSearches);
  }, []);

  return (
    <>
      <SidebarSummaryStyles>
        <SummaryHeader>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <OrderInfo>Order Details</OrderInfo>
            <XIconSmall style={{ cursor: 'pointer', height: 18, width: 18 }} onClick={props.onClick} />
          </div>
          {/* <div style={{ display: 'flex' }}>
            <TabStyles
              backgroundColor={orderSummaryOpen ? true : false}
              border={orderSummaryOpen ? true : false}
              color={orderSummaryOpen ? '#33322F' : '#BCC2C7'}
              onClick={() => (
                setOrderSummaryOpen(true), setActivityOpen(false)
              )}
            >
              Order Summary
            </TabStyles>
            <TabStyles
              backgroundColor={activityOpen ? true : false}
              border={activityOpen ? true : false}
              color={activityOpen ? '#33322F' : '#BCC2C7'}
              onClick={() => (
                setActivityOpen(true), setOrderSummaryOpen(false)
              )}
            >
              Activity
            </TabStyles>
          </div> */}
        </SummaryHeader>
        <OuterWrap>
          {/* {orderSummaryOpen && (
            <div>
              <div style={{ display: 'flex', marginTop: 16 }}>
                <TitleStyles>Searches</TitleStyles>

                <div style={{ flexDirection: 'column' }}>
                  {Object.keys(grouped).map((key) => {
                    return (
                      <>
                        <div style={{ marginBottom: 16 }}>
                          {key}
                          <span style={{ color: '#93918F', marginLeft: 6 }}>
                            ({grouped[key].length})
                          </span>
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>
              <div style={{ display: 'flex', marginTop: 48 }}>
                <TitleStyles>Properties</TitleStyles>
                <div style={{ flexDirection: 'column', width: '70%' }}>
                  {props.order?.properties &&
                    props.order?.properties.map((p) => (
                      <>
                        <div style={{ display: 'flex', marginBottom: 6 }}>
                          <div>
                            {p.address} {p.addressLine2 && p.addressLine2}
                          </div>
                        </div>
                        <div style={{ marginBottom: 16, display: 'flex' }}>
                          <div style={{ width: 120 }}>Block: {p.block}</div>
                          <div>Lot: {p.lot}</div>
                        </div>
                      </>
                    ))}
                </div>
              </div>
              <div style={{ display: 'flex', marginTop: 48 }}>
                <TitleStyles>Names</TitleStyles>
                <div style={{ flexDirection: 'column', width: '70%' }}>
                  {props.order?.contacts.map((c) => (
                    <div style={{ display: 'flex', marginBottom: 16 }}>
                      {c.contactType === 'Borrower'
                      ? props.order.isPurchase
                        ? 'Buyer'
                        : 'Borrower'
                      : c.contactType}: {c.name}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )} */}

          <div>
            {/* {props.order.enteredByUser !== null && (
                <div style={{ display: 'flex', marginTop: 10 }}>
                  <TitleStyles>Ordered By</TitleStyles>
                  <div style={{ flexDirection: 'column' }}>
                    {props.order.enteredByUser.firstName}
                    {props.order.enteredByUser.lastName}
                    <div style={{ paddingTop: 6 }}>
                      {props.order.enteredByUser.email}
                    </div>
                  </div>
                </div>
              )} */}
            <div style={{ display: 'flex', marginTop: 16, alignItems: 'center' }}>
              <TitleStyles>Client</TitleStyles>
              <div>{props.order.clientName}</div>
            </div>
            <div style={{ display: 'flex', marginTop: 16, alignItems: 'center' }}>
              <TitleStyles>Ordered On</TitleStyles>
              <div>{date}</div>
            </div>
            <div style={{ display: 'flex', marginTop: 16, alignItems: 'center' }}>
              <TitleStyles>Priority</TitleStyles>
              <div>{props.status}</div>
            </div>
            {props.order.documents?.length > 0 && <Files order={props.order} />}
            <OrderCompleted searches={searches} />
            <SearchesDelivered searches={searches} />
          </div>
        </OuterWrap>
      </SidebarSummaryStyles>
    </>
  );
};

export default SidebarSummary;
